import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from 'material-ui/CircularProgress';

import VesselClaimsList from './List';
import { getVesselClaims } from 'actions/vessels/claims';

import styles from 'styles/index';

class VesselClaimsListPage extends React.Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.getVesselClaims();
    }

    render() {
        const { isLoaded } = this.props;

        return (
            <div id='vessel-claims' className='page'>
                <CircularProgress
                    className={!isLoaded ? '' : 'hidden'}
                    style={styles.circularProgress}
                />

                <div className={isLoaded ? '' : 'hidden'}>
                    <div className='container'>
                        <h2>
                            Vessel claims
                        </h2>
                        <VesselClaimsList />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ user : { isLogged }, vesselClaims: { isLoaded }}) => {
        return {
            isLogged,
            isLoaded,
        };
    },
    dispatch => bindActionCreators({
        getVesselClaims,
    },
    dispatch),
)(VesselClaimsListPage);



// WEBPACK FOOTER //
// ./app/components/Vessels/Claims/Page.jsx